<template>
  <div class="custom-tabs">
    <!-- 自定义胶囊式tab切换栏（新增下划线结构） -->
    <div
      v-for="tab in tabs"
      :key="tab.value"
      class="tab-item"
      :class="{ active: activeTab === tab.value }"
      @click="handleTabClick(tab.value)"
    >
      <span class="tab-text">{{ tab.label }}</span>
      <!-- 选中态下划线 -->
      <div class="tab-underline" v-show="activeTab === tab.value"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CustomTabs",
  props: {
    tabs: {
      type: Array,
      required: false,
      default: () => [],
    },
    activeTab: {
      type: String,
      required: false,
      default: "keyword",
    },
  },
  methods: {
    handleTabClick(tabValue) {
      this.$emit("tabChange", tabValue);
    },
  },
};
</script>

<style scoped lang="scss">
/* 自定义胶囊式tab切换栏（新增下划线结构） */
.custom-tabs {
  display: flex;
  gap: 12px;
  margin-bottom: 20px;

  .tab-item {
    padding: 5px 13px 0;
    border-radius: 999px;
    font-size: 12px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
    border: 1px solid #e4e7ed;
    background-color: #fff;
    color: #333;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;

    &.active {
      background: linear-gradient(90deg, #409eff 0%, #1890ff 100%);
      color: #fff;
      border-color: #1890ff;
      box-shadow: 0 2px 8px rgba(24, 144, 255, 0.3);
    }

    &:not(.active):hover {
      border-color: #c6e2ff;
      color: #1890ff;
    }

    .tab-text {
      margin-bottom: 4px;
    }

    .tab-underline {
      width: 24px;
      height: 2px;
      background-color: #fff;
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;
    }
  }
}
</style>
